<template>
    <div class="container search">
        <div class="row">
            <div class="col-md-12">
                <div class="row flex-column-reverse flex-sm-row">
                    <div class="col-md-6">
                        <h2>
                            Edit Claim - {{claim_id}}
                        </h2>
                    </div>
                </div>
                <EditClaim :claim_id="claim_id"></EditClaim>
            </div>
        </div>
    </div>
</template>
<script>
import EditClaim from './EditClaim.vue'
import axios from "axios";
export default {
    props: [
        'claim_id',
    ],
    components: {
        EditClaim
    },
    created() {
    },
    mounted() {
    },
    data() {
        return {
            claim: null
        }
    },
    computed: {},
    methods: {
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Claims/EditClaimPage.vue